import { connect } from 'react-redux';
import { isBusy, isError, getErrorMsg, getFocus } from '../../selectors';
import { getRequiresFallback } from '../../../DaEditorWrapper/redux/selectors';
var mapStateToProps = function (state, ownProps) { return ({
    isBusy: isBusy(state, ownProps.id),
    isError: isError(state, ownProps.id),
    errorMsg: getErrorMsg(state, ownProps.id),
    focus: getFocus(state, ownProps.id, ownProps.autoFocus),
    requiresPlaintext: getRequiresFallback(state),
}); };
var mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps, null, {
    forwardRef: true,
});
//# sourceMappingURL=CommentBoxEditor.container.js.map